import { Routes, Route } from "react-router-dom";
import Top from "./Pages/top"
import Header from "./Component/Header";
import Footer from "./Component/Footer"
import Home from "./Pages/Home";
import About from "./Pages/About";
import MDMessage from "./Corporate/MD";
import BM from "./Corporate/BM";
import SM from "./Corporate/SM";
import Contact from "./Pages/Contact";
import Career from "./Pages/Career";
import Vision from "./Pages/Vision";
import Services from "./Pages/Service";
import Transmission from "./Service/Transmission";
import Cable from "./Service/Cable";
import Electric from "./Service/Electric";
import Light from "./Service/Light";
import Sub from "./Service/Sub";
import Renewable from "./Service/Renewable";
import CSR from "./Pages/CSR";
import Award from "./Pages/Award";
import Disclaimer from "./Pages/Disclaimer";
import PrivacyPolicy from "./Pages/Privacy";
import Projects from "./Pages/Project";
import ProjectDetail from "./Pages/ProjectDetail";
import WhyUs from "./Pages/WhyUs";
import TeamDetail from "./Corporate/Teamdetail";
import Investor from "./Pages/Investor";
import Presence from "./Pages/Presence";
import Query from "./Pages/Query";
// import Demo from "./Component/Demo";
// import InvestorGrievance from "./Pages/InvestorGrievance";


import ProjectsCarousel from "./Pages/PP";


function App() {
  return (
    <>
      <Top />
      <Header /> 
      {/* <Demo /> */}
    <Routes>

      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/career" element={<Career />} />
      <Route path="/vision" element={<Vision />} />
      <Route path="/presence" element={<Presence />} />
      <Route path="/csr" element={<CSR />} />
      <Route path="/award" element={<Award />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/service" element={<Services />} />
      <Route path="/why-us" element={<WhyUs />} />
      <Route path="/query" element={<Query />} />




      <Route path="/Corporate/MD" element={<MDMessage />} />
      <Route path="/Corporate/BM" element={<BM />} />
      <Route path="/Corporate/SM" element={<SM />} />

      <Route path="/Service/Transmission" element={<Transmission />} />
      <Route path="/Service/Cable" element={<Cable />} />
      <Route path="/Service/Electric" element={<Electric />} />
      <Route path="/Service/Light" element={<Light />} />
      <Route path="/Service/Sub" element={<Sub />} />
      <Route path="/Service/Renewable" element={<Renewable />} />

      <Route path="/team/:id" element={<TeamDetail />} />


      <Route path="/projects" element={<Projects/>} />
      <Route path="/project/:id" element={<ProjectDetail />} />


      <Route path="/investor/:category" element={<Investor />} />
    {/* <Route path="/investor-grievance-contact" element={<InvestorGrievance />} /> */}


      {/* <Route path="/projects-carousel" element={<ProjectsCarousel />} /> */}
      {/* <Route path="/project/:id" element={<ProjectDetail />} /> */}

    </Routes>
      <Footer />
</>
  );
}

export default App;
